import useTicketMutations from "../../data/Ticket/useTicketMutations";
import { TicketPriority } from "../../models/Tickets/Ticket";
import TicketPillMenu from "./TicketPillMenu";
import {
  priorityClassMap,
  ticketPriorityLabels,
  ticketPriorityOptions,
} from "./ticketMeta";

interface TicketPriorityMenuProps {
  ticketId: string;
  priority: TicketPriority;
  className?: string;
}

/**
 * The priority pill doubles as its own editor - picking a value sends a partial
 * update, so nothing else on the ticket is touched.
 */
export default function TicketPriorityMenu({
  ticketId,
  priority,
  className,
}: TicketPriorityMenuProps) {
  const { update } = useTicketMutations();

  return (
    <TicketPillMenu
      value={priority}
      options={ticketPriorityOptions}
      labels={ticketPriorityLabels}
      classMap={priorityClassMap}
      onSelect={(next) => update.mutate({ id: ticketId, priority: next })}
      isPending={update.isPending}
      title="Change priority"
      className={className}
    />
  );
}
